import type { RowData } from "@tanstack/react-table";
import clsx from "clsx";
import type { ChildrenProps } from "../../types";
import { getCellMeta } from "./handlers";
import type { Cell } from "./types";
import { getCommonPinningStyles } from "./utils";

/** Props Interface */
interface DataTableTdProps<T extends RowData> extends ChildrenProps {
	cell: Cell<T, unknown>;
}

export function DataTableTd<T extends RowData>({ cell, children }: DataTableTdProps<T>) {
	/** Computed */
	const isPinned = cell.column.getIsPinned();
	const meta = getCellMeta(cell);

	/** Render */
	return (
		<div
			data-pinned-left={isPinned === "start" ? true : undefined}
			data-pinned-right={isPinned === "end" ? true : undefined}
			style={getCommonPinningStyles(cell.column)}
			className={clsx(
				meta?.isNumeric && "text-right pr-2",
				meta?.isTabular || meta?.isNumeric ? "tabular-nums" : "normal-nums",
				"table-td",
				meta?.withoutPadding && "table-td-without-padding",
				meta?.mono && "font-mono",
				meta?.capitalize && "capitalize",
				meta?.className,
			)}
		>
			{children}
		</div>
	);
}
